
import React, { useState } from "react";
import { ThemeClasses } from "./CraftGeneratorTheme";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { X } from "lucide-react";

interface CraftIdeasResultProps {
  craftIdeas: string[];
  themeClasses: ThemeClasses;
}

const CraftIdeasResult: React.FC<CraftIdeasResultProps> = ({ 
  craftIdeas, 
  themeClasses 
}) => {
  const isMobile = useIsMobile();
  const [expandedIdea, setExpandedIdea] = useState<number | null>(null);

  if (craftIdeas.length === 0) {
    return null;
  }

  // For mobile devices, use a more compact layout with expandable items
  if (isMobile) {
    return (
      <div className={themeClasses.resultClass}>
        <h3 className="text-lg font-medium mb-2">Craft Ideas:</h3>
        <ul className="space-y-3">
          {craftIdeas.map((idea, index) => (
            <li key={index} className="border rounded-md p-2">
              <div className="flex items-start justify-between">
                <div className={`${expandedIdea === index ? '' : 'line-clamp-2'}`}>
                  {idea}
                </div>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  className="ml-2 h-7 px-2 shrink-0"
                  onClick={() => setExpandedIdea(expandedIdea === index ? null : index)}
                >
                  {expandedIdea === index ? "Less" : "More"}
                </Button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  // For desktop, use the original layout
  return (
    <div className={themeClasses.resultClass}>
      <h3 className="text-lg font-medium mb-2">Craft Ideas:</h3>
      <ul className="list-disc pl-5 space-y-2">
        {craftIdeas.map((idea, index) => (
          <li key={index}>{idea}</li>
        ))}
      </ul>
    </div>
  );
};

export default CraftIdeasResult;
